import { useState } from 'react';
import VirtualHostSetupWizard from '@/components/virtual-host/setup/VirtualHostSetupWizard';

/**
 * AI Host Setup Page
 *
 * This page hosts the 5-step setup wizard for AI Host service.
 * Requires authentication - restaurant owners set up:
 * 1. Phone number (Twilio)
 * 2. Payment account (Stripe Connect)
 * 3. Service preferences
 * 4. Go live
 */
export default function VirtualHostSetup() {
  const [isWizardOpen, setIsWizardOpen] = useState(true);

  const handleClose = () => {
    setIsWizardOpen(false);
    // Redirect to dashboard or AI Host control center
    window.location.href = '/restaurant-dashboard';
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <VirtualHostSetupWizard
        isOpen={isWizardOpen}
        onClose={handleClose}
      />
    </div>
  );
}
